import { useEventListener } from '@vueuse/core'
import type { DirectiveBinding } from 'vue'

export type TrackEventData = {
  event?: string
  eventCategory?: string
  eventAction?: string
  eventLabel?: string
}

const DEFAULT_DATA: TrackEventData = {
  //
}

export function trackEvent (data: TrackEventData) {
  if (!data) return
  if (!window.dataLayer) window.dataLayer = []
  window.dataLayer.push({ ...DEFAULT_DATA, ...data })
}

export default {
  mounted: (el: HTMLElement, bindings: DirectiveBinding<TrackEventData>) => {
    useEventListener(el, 'click', () => trackEvent(bindings.value))
  }
}
